import { Box, Typography } from '@mui/material';
import { Button, useTimezoneWarning } from '@uplift/ui-v2';
import { useSelectedProviderStyles } from '../styles';
import { CalendarDateService, DateObject } from '@uplift/services';
import { ProviderMedicalRole } from '@uplift/types';
import { useSelectedProviderContext } from '../selected-provider.context';
import { useMemo } from 'react';
import { useUpBreakpoint } from '@uplift/hooks';

type ScheduleSessionFooterProps = {
  onClick: () => void;
  nextAvailable: DateObject | undefined;
};

export const ScheduleSessionFooter: React.VFC<ScheduleSessionFooterProps> = props => {
  const isSmUp = useUpBreakpoint('sm');
  const { selectedProvider } = useSelectedProviderContext();
  const { classes } = useSelectedProviderStyles();
  const { isActive: isTimezoneWarningActive } = useTimezoneWarning();

  const message = useMemo(() => {
    if (!props.nextAvailable) {
      // day load limits differ per medical role
      const timeline = selectedProvider.medicalRole === ProviderMedicalRole.therapist
        ? '2 weeks'
        : '30 days';

      return <Typography variant="body2" color="textPrimary">{selectedProvider.nameDisplay.first} is not available in the next {timeline}.</Typography>;
    }

    const nextAvailable = CalendarDateService.date(props.nextAvailable).format('MMM DD');

    return (
      <div>
        <Typography variant="body2" color="textPrimary">Next Available:</Typography>
        <Typography variant="body2" color="textPrimary">{nextAvailable}</Typography>
      </div>
    );
  }, [ props.nextAvailable, selectedProvider.medicalRole, selectedProvider.nameDisplay.first ]);

  if (isSmUp) return null;

  return (
    <Box className={classes.scheduleSessionFooter}>
      <Box display="flex" justifyContent="space-between" p={2} gap="0.5rem" alignItems="center">
        {message}
        {/* flexShrink={0} so button doesn't wrap */}
        <Box flexShrink={0}>
          <Button
            variant="contained"
            color="secondary"
            onClick={props.onClick}
            disabled={!props.nextAvailable || isTimezoneWarningActive}
          >
            Schedule Session
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
